import { render, staticRenderFns } from "./importStock.vue?vue&type=template&id=4b48033f&scoped=true&"
import script from "./importStock.vue?vue&type=script&lang=js&"
export * from "./importStock.vue?vue&type=script&lang=js&"
import style0 from "./importStock.vue?vue&type=style&index=0&id=4b48033f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b48033f",
  null
  
)

export default component.exports